<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { navigateToStore } from '@/services/navigate-to-store';

defineProps<{ open: boolean }>();
const { t } = useI18n();
</script>

<template>
  <div v-if="open" class="app-force-update">
    <div class="flex flex-col items-center text-center px-8 max-w-md">
      <ion-text class="text-h4 mb-2">{{ t('force-update.title') }}</ion-text>
      <ion-text class="text-p text-light-medium mb-8">{{ t('force-update.subtitle') }}</ion-text>
      <base-button shape="round" color="primary" class="w-full" @click="navigateToStore">
        {{ t('force-update.button') }}
      </base-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.app-force-update {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background-color: #202020;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
